import { matchRoutes, RouteObject } from "react-router-dom";
import { routeConfig } from "@/app/providers/router/config/routeConfig";
import type { AppRoutesProps } from "@/shared/types/router";

// То же дерево, что строит AppRouter, только без элементов: нужен шаблон
// маршрута (":lang/cut-videos/:cutId"), чтобы журнал группировался по экранам.
const toRoute = (r: AppRoutesProps): RouteObject =>
    r.index
        ? { index: true }
        : {
              path: (r.path ?? "").replace(/^\//, ""),
              children: r.children?.map(toRoute),
          };

const ROUTES: RouteObject[] = [
    { path: "/" },
    { path: "/live-egress-layout" },
    { path: ":lang", children: [{ index: true }, ...Object.values(routeConfig).map(toRoute)] },
    { path: "*" },
];

const cache = new Map<string, string>();

export const routePattern = (pathname: string): string => {
    const hit = cache.get(pathname);
    if (hit !== undefined) return hit;
    const matches = matchRoutes(ROUTES, pathname) || [];
    const pattern =
        matches
            .map((m) => (m.route.path || "").replace(/^\/+|\/+$/g, ""))
            .filter(Boolean)
            .join("/") || "/";
    if (cache.size > 500) cache.clear();
    cache.set(pathname, pattern);
    return pattern;
};
